import { getLocalTimeZone } from '@internationalized/date';

const TZID_STORAGE_KEY = 'ld-flag-targeting-last-used-tzid';

/** Persists the user's last-used IANA timezone to localStorage so it can be restored on the next modal open. Mirrors legacy `saveTzidToCache` behavior. */
export function saveTzidToCache(tzid: string): void {
  try {
    localStorage.setItem(TZID_STORAGE_KEY, tzid);
  } catch {
    // localStorage unavailable
  }
}

/** Returns the last-used IANA timezone from localStorage, falling back to the browser's local timezone. Mirrors legacy `lastUsedTzid`. */
export function lastUsedTzid(): string {
  try {
    return localStorage.getItem(TZID_STORAGE_KEY) || getLocalTimeZone();
  } catch {
    return getLocalTimeZone();
  }
}
